import styled from 'styled-components'

export const StoreBox = styled.div`
    display: -webkit-box;
    min-height: unset;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 10px;
    border-bottom: #e2e2e2;
    border-bottom-width: 1px;
    border-bottom-style: solid;
`
export const Name = styled.span`
    font-size: 16px;
    font-weight: bold;
    color: #414042;
`
export const Info = styled.span`
    font-size: 14px;
    color: slategray;
    line-height: 20px;
`

export const Availability = styled.span`
    font-size: 14px;
    font-weight: bold;
    color: #fa6400;
`

export const SelectStoreButton = styled.button`
    font-size: 14px;
    font-weight: bold!important;
    border: none;
    cursor: pointer;
    padding: 0;
    color: #0071c3;
    width: 100%;
    height: 37px;
    border-radius: 20.5px;
    box-shadow: 0 2px 4px 0 rgba(173, 172, 172, 0.5);
    border: solid 1px #0071c3;
    background-color: #ffffff;
    transition: color .5s;
    text-transform: none!important;

    :after {
        content: 'Seleccionar local'
    }

    &.selected {
        color: #ffffff;
        background-color: #0071c3;
    }

    &.selected:after {
        content: '¡Guardado!'
    }

    @media (max-width: 768px) {
        :after {
            content: 'Seleccionar'
        }
    }
`
